var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12.833,
    viewBox: "0 0 19 12.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-390 -39.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    transform: "translate(390 39.75)",
    fill: "#fff",
    stroke: "#495584",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 17.7,
    height: 0.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    transform: "translate(390 51.083)",
    fill: "#fff",
    stroke: "#495584",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 17.7,
    height: 0.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    transform: "translate(390 45.417)",
    fill: "#fff",
    stroke: "#495584",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 13.7,
    height: 0.2,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.49b1b3a7.svg";
export { ForwardRef as ReactComponent };